angular.module('dealerware.web.data').factory('DealerwareNoteCollection', function ($http,Collection,DealerwareNoteModel,$q) {

    'use strict';
    var collection = new Collection({
        baseEndpoint: '/locations/:location_id/:type/:model_id/notes',
        model: 'DealerwareNoteModel',
        params: {
            sort_by: 'created_at',
            sort_direction: 'desc'
        },
        customActions: {
            index: {
                method: 'GET',
                ignoreDefaultRootNodeResponse: true,
                ignoreDefaultAssociationMapper: true
            }
        }
    });

    jQuery.extend(collection.prototype,{
        toSummaryString: function() {
            return this.pagination && isObject(this.pagination) && this.pagination.total >= 0 ? 'Notes: ' + this.pagination.total : '';
        }
    });

    return collection;
});